import enquireJs from 'enquire.js'
import { Plugins } from '@/acl/plugins'
import { mapState } from 'vuex'

export const DEVICE_TYPE = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile'
}

export const deviceEnquire = function (callback) {
  const matchDesktop = {
    match: () => {
      callback && callback(DEVICE_TYPE.DESKTOP)
    }
  }

  const matchLablet = {
    match: () => {
      callback && callback(DEVICE_TYPE.TABLET)
    }
  }

  const matchMobile = {
    match: () => {
      callback && callback(DEVICE_TYPE.MOBILE)
    }
  }

  // screen and (max-width: 1087.99px)
  enquireJs
    .register('screen and (max-width: 576px)', matchMobile)
    .register('screen and (min-width: 576px) and (max-width: 1299px)', matchLablet)
    .register('screen and (min-width: 1200px)', matchDesktop)
}

export const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.device
    })
  },
  methods: {
    isMobile () {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop () {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet () {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
}

export const mixinPermission = {
  methods: {
    checkPermission (resourceName, behavior, options) {
      const permission = Plugins.check(resourceName, [behavior], options)
      return permission
    }
  }
}

export const mixinLabeling = {
  computed: {
    fileKey () {
      return this.$route.params.key || null
    },
    stepName () {
      return this.$route.params.step || null
    },
    currentFile () {
      if (this.fileKey === null) return null
      const files = this.$store.state.file.files
      if (files === null) return null
      return files.find(x => x.key === this.fileKey) || null
    },
    currentStep () {
      if (this.stepName === null) return null
      const steps = this.$store.state.workspace.steps
      if (steps === null) return null
      return steps.find(x => x.name === this.stepName) || null
    }
  }
}
